/**
 * issue #109: 経過ミリ秒を日本語 duration 表記に。
 * <60秒: 「23秒」 / 60秒〜<60分: 「1分23秒」(秒0埋め) / ≥60分: 「1時間03分」(分0埋め・秒省略)。
 * 負値は0クランプ。
 */
export function formatDuration(ms: number): string {
  const totalSec = Math.floor(Math.max(0, ms) / 1000);
  if (totalSec < 60) return `${totalSec}秒`;
  const totalMin = Math.floor(totalSec / 60);
  if (totalMin < 60) {
    const sec = totalSec % 60;
    return `${totalMin}分${String(sec).padStart(2, '0')}秒`;
  }
  const hr = Math.floor(totalMin / 60);
  const min = totalMin % 60;
  return `${hr}時間${String(min).padStart(2, '0')}分`;
}
